import React from 'react';
import { Control } from 'react-redux-form';
import PlacesAutocomplete, { geocodeByAddress } from 'react-places-autocomplete';
import { actions } from 'react-redux-form';
import { connect } from 'react-redux';

const mapStateToProps = state => ({
    searchTripsForm:  state.searchTripsForm,
    addTripForm:      state.addTripForm,
    addDeliveryForm:  state.addDeliveryForm,
});

const mapDispatchToProps = dispatch => ({
    changeAndSubmit: (model, value) => dispatch(actions.change(model, value)),
});

const DROPDOWN_STYLE = {
    position:     'absolute',
    top:          'calc(100% + 4px)',
    left:         0,
    right:        0,
    zIndex:       9999,
    background:   '#ffffff',
    borderRadius: 12,
    boxShadow:    '0 8px 24px rgba(0,0,0,0.14)',
    border:       '1px solid #e9ecef',
    overflow:     'hidden',
};

const ITEM_BASE = {
    display:    'flex',
    alignItems: 'center',
    gap:        10,
    padding:    '11px 16px',
    cursor:     'pointer',
    fontSize:   '0.92rem',
    fontFamily: "'Inter', sans-serif",
    color:      '#0a2540',
    borderBottom: '1px solid #f0f0f0',
    lineHeight: 1.4,
};

class LocationSearchInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = { address: '' };
    }

    componentDidMount() {
        const model = this.props.model.toString().replace('.', '');
        let rawValue = '';
        if      (this.props.formName === 'searchTripsForm') rawValue = this.props.searchTripsForm[model]  || '';
        else if (this.props.formName === 'addTripForm')     rawValue = this.props.addTripForm[model]      || '';
        else                                                rawValue = this.props.addDeliveryForm[model]  || '';
        const parts = rawValue.split('--');
        this.setState({ address: parts[1] !== undefined ? parts[1] : (parts[0] || '') });
    }

    handleChange = (address) => {
        this.setState({ address });
    };

    handleClear = () => {
        this.setState({ address: '' });
        this.props.changeAndSubmit(`${this.props.formName}${this.props.model}`, '');
    };

    handleSelect = (address) => {
        geocodeByAddress(address)
            .then(results => {
                const components = results[0].address_components;
                for (let p = components.length - 1; p >= 0; p--) {
                    if (components[p].types.indexOf('locality') !== -1) {
                        const city          = components[p].long_name;
                        const formattedAddr = results[0].formatted_address;
                        this.setState({ address: formattedAddr });
                        this.props.changeAndSubmit(
                            `${this.props.formName}${this.props.model}`,
                            `${city}--${formattedAddr}`
                        );
                        if (this.props.onClickSuggestionItem) this.props.onClickSuggestionItem();
                        break;
                    }
                }
            })
            .catch(error => console.error('Geocode error', error));
    };

    render() {
        const { address } = this.state;
        const isHome = window.location.pathname === '/home';

        return (
            <PlacesAutocomplete
                value={address}
                onChange={this.handleChange}
                onSelect={this.handleSelect}
            >
                {({ getInputProps, suggestions, getSuggestionItemProps }) => (
                    <div style={{ position: 'relative' }}>

                        {/* Input */}
                        <Control.text
                            style={{
                                backgroundColor: isHome ? 'white' : undefined,
                                paddingRight: address ? '2.6rem' : undefined,
                            }}
                            {...getInputProps({
                                placeholder: this.props.placeholder,
                                model:       this.props.model,
                                id:          this.props.id,
                                name:        this.props.name,
                                autoFocus:   this.props.autoFocus,
                                className:   'form-control',
                            })}
                        />

                        {/* Bouton effacer / icône localisation */}
                        {address ? (
                            <button
                                type="button"
                                onClick={this.handleClear}
                                style={{
                                    position: 'absolute', right: 10, top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: '#b0bec5', border: 'none',
                                    borderRadius: '50%', width: 20, height: 20,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    cursor: 'pointer', color: 'white', fontSize: '0.6rem',
                                    zIndex: 10, padding: 0, lineHeight: 1,
                                }}
                                title="Effacer"
                            >
                                ✕
                            </button>
                        ) : (
                            <i className="fa fa-map-marker localisationCity" />
                        )}

                        {/* Dropdown suggestions */}
                        {suggestions.length > 0 && (
                            <div style={DROPDOWN_STYLE}>
                                {suggestions.map((suggestion, idx) => {
                                    const itemProps = getSuggestionItemProps(suggestion);
                                    return (
                                        <div
                                            key={idx}
                                            {...itemProps}
                                            style={{
                                                ...ITEM_BASE,
                                                background: suggestion.active ? '#f0f9ff' : '#ffffff',
                                                borderBottom: idx === suggestions.length - 1 ? 'none' : '1px solid #f0f0f0',
                                            }}
                                        >
                                            <span style={{
                                                width: 28, height: 28, borderRadius: 8, flexShrink: 0,
                                                background: '#e0f5fe', display: 'flex',
                                                alignItems: 'center', justifyContent: 'center',
                                            }}>
                                                <i className="fa fa-map-marker" style={{ color: '#00AFF5', fontSize: '0.78rem' }} />
                                            </span>
                                            <span style={{ flex: 1, color: '#0a2540', fontFamily: "'Inter', sans-serif" }}>
                                                {suggestion.description}
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                )}
            </PlacesAutocomplete>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LocationSearchInput);
